import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async extrairNumerosProcesso ({ commit }, caminho) {
    const data = await axios({
      method: 'GET', url: 'planilha/extrairNumerosProcesso', params: { caminho }
    })
    return data
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/planilha/planilha.js